/*
defines the data structure for image nodes
*/

import Node from './node';

/**
 * represents a node containing an image
 */
export default class ImageNode extends Node {
    /**
     *
     * @param {number} id
     * @param {Function} updateCallback
     * @param {Object} apiSource
     * @param {Object} apiResponse (optional) default api response object
     */
    constructor(id, updateCallback = function() {}, apiSource = {}, apiResponse = {}, name, image, style, source) {
        super(id, updateCallback);
        this.apiSource = apiSource;
        this.apiResponse = apiResponse;
        this.image = image;
        this.dbimage = image;
        this.name = name;

        this.getImage();

        if (Object.keys(this.apiSource).length < 2) {
            this.apiSource = this.getAPISource(style, source);
        }

        this.type = 'image'; // TODO: check if match apiSource
        if (_.isEmpty(apiSource) && _.isEmpty(apiResponse)) {
            console.error('problem creating imagenode: no api source or response given');
        }
        if (!_.isEmpty(apiSource) && apiSource.type !== this.type) {
            console.error(`api type is ${apiSource.type} but node type is ${this.type}`);
        }
    }

    /**
     * given information about an API, makes an ajax call using the given url, given request object, and headers
     * @param {Object} apiSource information about the API to be called
     */
    getNewNodeData() {
        super.getNewNodeData();
    }

    /**
     * gets the image object for this node
     * retrieved using this.image
     * always returns an object of the form {url: ..., width: .., height: ... }
     * accessed by calling this.image.url, this.image.width, etc
     */
    getImage() {
        let image;
        if (Object.keys(this.apiResponse).length === 0) {
            this.setUpdateCallback(this.updateCallback);
            image = null;
        } else if (this.name === 'DB') {
            image = this.dbimage;
        } else {
            image = this.apiSource.image(this.apiResponse);
        }

        this.image = image;
        console.log('get image', this.image);

        return image;
    }
}
